const ZoneHeading = ({ id, children }) => {
    return <h2 className="zone-heading">{children}<span className="zone-heading-anchor" id={id} /></h2>
}

export default ZoneHeading;